import Canoo from "../../img/work/canoo.png"
import Bill from "../../img/work/bill.png"
import Huddle from "../../img/work/huddle.png"
import Ansari from "../../img/work/ansari.png"
import Wiemeyer from "../../img/work/wiem.png"
import Buck from "../../img/work/buck.png"


export const WorkData = [
    {
        name: "Bill",
        description:
            "Frontend Software Engineer Intern at Bill.com for Summer of 2021",
        link: "https://www.bill.com",
        image: Bill,
    },
    {
        name: "Canoo",
        description:
            "Software Engineering Intern at Canoo working on the Software Operations team",
        link: "https://www.canoo.com",
        image: Canoo,
    },
    {
        name: "Huddle",
        description:
            "Frontend Developer at my video calling startup. Built with ReactJS and Typescript.",
        link:
            "https://www.figma.com/proto/bIZjdxgWVmlglhNy9xBvHb/huddle-Deck-Vicky-Li?node-id=1%3A138&scaling=contain",
        image: Huddle,
    },
    {
        name: "Ansari",
        description:
            "Freelance Web Developer at Ansari Math. Used ReactJS, AWS, and Axios.",
        link: "http://ansarimath.com/",
        image: Ansari,
    },
    {
        name: "Wiemeyer",
        description:
            "Freelance Frontend Web Developer at Wiemeyer Dentistry.",
        link: "https://www.wiemeyerdentistry.com/",
        image: Wiemeyer,
    },
    {
        name: "Buck",
        description:
            "Marketing/CRM Intern at Buck.ai. Used Python and Jupyter to manage CRM.",
        link: "http://buck.ai/",
        image: Buck,
    },
    
]
